interface StarIconProps {
  filled?: boolean;
  size?: number;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

export default function StarIcon({
  filled = false,
  size = 18,
  onClick,
  className = ""
}: StarIconProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center hover:scale-110 transition-transform ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? "#FFD700" : "none"}
        stroke={filled ? "#FFD700" : "#CCCCCC"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </button>
  );
}
